import { all, takeLatest } from 'redux-saga/effects';

import {
  fetchInvoicesElectricityService,
  fetchInvoicesWaterService,
  fetchInvoicesElectricityGasService,
} from '../services';
import EntryActionTypes from '../../../constants/EntryActionTypes';

export default function* reportsWatchers() {
  yield all([
    takeLatest(
      EntryActionTypes.INVOICES_ELECTRICITY_FETCH_REQUEST,
      ({ payload: { currentMonth } }) => fetchInvoicesElectricityService(currentMonth),
    ),
    takeLatest(EntryActionTypes.INVOICES_WATER_FETCH_REQUEST, ({ payload: { currentMonth } }) =>
      fetchInvoicesWaterService(currentMonth),
    ),
    takeLatest(EntryActionTypes.INVOICES_GAS_FETCH_REQUEST, ({ payload: { currentMonth } }) =>
      fetchInvoicesElectricityGasService(currentMonth),
    ),
  ]);
}
